export const adminDataGridSx = {
  border: 'none',
  '& .MuiDataGrid-columnHeaders': {
    backgroundColor: '#F5F0E8',
    fontWeight: 700,
    fontSize: '0.75rem',
    textTransform: 'uppercase',
    letterSpacing: '0.05em',
    color: '#5C5A55',
  },
  '& .MuiDataGrid-row:hover': {
    backgroundColor: '#FAF7F2',
  },
  '& .MuiDataGrid-cell': {
    fontSize: '0.85rem',
  },
  '& .MuiDataGrid-footerContainer': {
    backgroundColor: '#F5F0E8',
  },
};
